import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import { Context } from '@routes/private/Editor/Context';
import { getDifferentValues } from 'utils/multiEditing';
import ColorPicker from 'routes/private/Editor/Editor/Pickers/ColorPicker';
import {getTaggedVisibleElementsId} from 'utils/selectDescribe'
import { isCloseToWhite } from '@utils/colors'

const MultiEditingColorAttribute:React.FC<IProps> = (props) => {
  const [values, setValues]= useState<string[]>([]);
  const [showPicker, setShowPicker]= useState(false);
  const context = useContext(Context);

  const onChangeValue = (newValue: string) => {
    setValues([newValue]);
  }

  const handleFocus = () => {
    setShowPicker(!showPicker);
    context.onMultiEditingFocus([props.selectDescribeFieldId]);
    const differentValues = getDifferentValues(props.name,props.elementType,props.selectDescribeFieldId,context.data,context.selectDescribe?.taggedFields);
    setValues(differentValues);
  }

  useEffect(() => {
    const differentValues = getDifferentValues(props.name,props.elementType,props.selectDescribeFieldId,context.data,context.selectDescribe?.taggedFields);
    setValues(differentValues);
  }, [context.data, props.fieldId])

  const isOneColorCloseToWhite = () => {
    for (let i=0;i<values.length;i++) {
      if(isCloseToWhite(values[i])) {
        return true;
      }
    }
    return false;
  } 

  return (
    <S.Root>
      
      <S.ControlContainer>
        <S.LabelTitle>
          {
            props.label
          }
        </S.LabelTitle>
        <S.ColorContainer>
          <S.ColorRect hasOneColorCloseToWhite={isOneColorCloseToWhite()} onClick={()=>handleFocus()}>
            {
              values.length===0 &&
              <>
                <S.ColorSection hasOneColorCloseToWhite={false} backgroundColor={"#000000"} first={true} last={true}/>
              </>
            }
            {
              values.length>0 &&
              <>
              {
                values.map((value, index) => {
                  return (
                    <S.ColorSection
                      key={index}
                      hasOneColorCloseToWhite={isOneColorCloseToWhite()}
                      backgroundColor={value}
                      first={index === 0}
                      last={index === values.length - 1}
                    />
                  )
                })
              }
              </>
            }
          </S.ColorRect>
        </S.ColorContainer>
      </S.ControlContainer>
      {
        showPicker && 
        <S.PickerContainer>
          <S.ColorSpacer>
            <ColorPicker drawBox={false} onChangeValue={(newValue) => onChangeValue(newValue)} elementsIds={getTaggedVisibleElementsId([props.selectDescribeFieldId], context.selectDescribe!.taggedFields, context.data)} pickerProperties={{elementType: props.elementType, colorAttribute: (props.name as "color" | "backgroundColor")}}>
            </ColorPicker>  
          </S.ColorSpacer>
        </S.PickerContainer>
      }
    </S.Root>
  );
}

export default MultiEditingColorAttribute;

